import React from 'react'
import { useTranslation } from "react-i18next"
import './help-section-slider.pure.css'

const HelpSectionSliderVideosItemPure = (props) => {
    const { t } = useTranslation()
    const { video } = props
    return (
        <div>
            <p className="helpSecionPanel-content-title">{t('helpSection.sectionSelect.videoGuide')} {video.name}</p>
            <div className="helpSecionPanel-content-div-video">
                <iframe
                    width="258"
                    height="150"
                    src={video.url}
                    title={video.name}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                />
            </div>
        </div>
    )
}
export { HelpSectionSliderVideosItemPure as default }